<template>
  <div>
    <b-row class="mb-5">
      <b-col cols="12">
        <b-card
          style="background: transparent !important"
          class="card-diagnostic"
        >
          <template #header>
            <strong class="mb-0"
              >Detalle de la pérdida de capacidad laboral</strong
            >
          </template>
          <b-overlay :show="loading" rounded="sm">
            <template #overlay>
              <OverlayButton clase="overlay-md"> </OverlayButton>
            </template>
            <b-row>
              <b-col cols="6" class="mb-4">
                <Select
                  label="Diagnósticos"
                  name="diagnostic_ids"
                  v-model="formData.diagnostic_ids"
                  :required="true"
                  :options="diagnostics"
                  :value="formData.diagnostic_ids"
                  :multiple="true"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" class="">
                <UploadFile
                  title="Adjunta aquí el archivo soporte de perdida de capacidad laboral (PCL)"
                  @uploadFile="uploadFile"
                  titleDocumento="PCL"
                  :isBusy="isBusy"
                  :isEdit="isEdit"
                  :document="file1"
                  :id="'file-pcl-1'"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="mb-4">
                <Input
                  label="Porcentaje PCL"
                  name="percentage"
                  :required="true"
                  :type="'number'"
                  :value="formData.percentage"
                  :disabled="isEdit || isBusy"
                  @input="
                    (event) => (formData.percentage = event.target.value)
                  "
                />
              </b-col>
              <b-col cols="6" />
              <b-col cols="6" class="mb-4">
                <Date
                  name="pcl_document_date"
                  label="Fecha del documento de la PCL"
                  v-model="formData.pcl_document_date"
                  :required="true"
                  :value="formData.pcl_document_date"
                  :disabled="isEdit || isBusy"
                />
              </b-col>
              <b-col cols="6" />
              <b-col cols="6" class="mb-4">
                <Select
                  label="Compensación"
                  name="compensation"
                  v-model="formData.compensation"
                  :options="optionsCompensation"
                  :value="formData.compensation"
                  :disabled="isEdit || isBusy"
                  :required="true"
                  @onSelect="onSelectCompensation"
                />
              </b-col>
              <b-col cols="6" />
              <b-col cols="6" class="mb-4" v-if="isVisible">
                <Date
                  name="compensation_date"
                  label="Fecha compensación"
                  v-model="formData.compensation_date"
                  :value="formData.compensation_date"
                  :disabled="isEdit || isBusy"
                  :required="isVisible"
                />
              </b-col>
              <b-col cols="6" />
            </b-row>
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const { Select, Date, Textarea, Input } = useInputs();
import useInputs from "@/components/general/Inputs";
import UploadFile from "./UploadFile";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";

export default {
  components: {
    Select,
    Date,
    Textarea,
    UploadFile,
    Input,
    OverlayButton,
  },
  props: {
    diagnostics: {
      type: Array,
      default: () => [],
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      optionsCompensation: [
        {
          id: "with_compensation",
          name: "Con compensación",
        },
        {
          id: "without_compensation",
          name: "Sin compensación",
        },
        {
          id: "no_applicable_compensation",
          name: "No aplica",
        },
      ],
      formData: {
        diagnostic_ids: [],
        pcl_document_date: "",
        compensation: null,
        compensation_date: "", //Solo si tiene compensacion
        file: null,
        percentage: "",
      },
      file1: null,
      isVisible: false,
    };
  },
  watch: {
    formData: {
      handler() {
        this.$emit("changeForm", this.formData);
      },
      deep: true,
    },
    record() {
      const me = this;
      if (me.record) me.fillData();
    }
  },
  methods: {
    uploadFile(file) {
      const me = this;
      me.formData.file = file;
    },
    fillData() {
      const me = this;
      me.formData.compensation_date = me.record?.compensation_date ? me.record?.compensation_date : "";
      me.formData.pcl_document_date = me.record?.pcl_document_date ? me.record?.pcl_document_date : "";
      me.formData.compensation = me.optionsCompensation.find(x => x.id == me.record?.compensation);
      me.formData.percentage = me.record?.percentage ? me.record?.percentage : "";
      me.file1 = me.record?.file ? me.record?.file : null;
      me.record?.diagnostics_ids?.forEach(element => {
        const option = me.diagnostics.find(x => x?.id == element);
        if (option) {
          me.formData.diagnostic_ids.push({
            id: option.id,
            name: option.name
          })
        }
      });
    },
    onSelectCompensation(item) {
      const me = this;
      me.isVisible = item?.id == "with_compensation" ? true : false;
      if (!me.isVisible) me.formData.compensation_date = "";
    }
  },
};
</script>

<style lang="css">
.card-diagnostic .card-header {
  background: #f5f5f5 !important;
}
</style>
